const tones = [
  ['#e1eafa', '#344a79'],
  ['#e6f1ed', '#2f5e4f'],
  ['#f7ecdf', '#7a4d24'],
  ['#efeafb', '#5e497d'],
  ['#f7e7ed', '#7a4058'],
  ['#e4f0f4', '#2c5967'],
] as const;

export function avatarFallback(name: string) {
  const label = name.trim().replace(/\s+/g, ' ') || '影爸爸';
  const characters = Array.from(label);
  const words = label.split(' ');
  const initials = (
    /^[a-z\d ._-]+$/i.test(label) && words.length > 1
      ? words
          .slice(0, 2)
          .map((word) => Array.from(word)[0])
          .join('')
      : characters.slice(0, 2).join('')
  ).toUpperCase();
  const hash = characters.reduce((value, char) => (value * 31 + char.codePointAt(0)!) >>> 0, 0);
  const [background, color] = tones[hash % tones.length];
  return { label, initials, background, color };
}
